import { useFormContext, Controller } from 'react-hook-form';
import { TextField, TextFieldProps } from '@mui/material';
import InputMask from 'react-input-mask';

// Acrescentamos a prop mask como opcional
type Props = TextFieldProps & {
  name: string;
  mask?: string;
};

export default function RHFTextField({ name, mask, helperText, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        // Se a prop mask for informada, usamos o InputMask para encapsular o TextField
        if (mask) {
          return (
            <InputMask
              mask={mask}
              value={field.value || ''} // Garantir que o valor seja uma string (nunca undefined)
              onChange={(e) => {
                field.onChange(e); // Passando diretamente o valor do input
              }}
              onBlur={field.onBlur} // Passa o onBlur para o react-hook-form
              maskChar={null} // Remove o caractere de máscara padrão ('_')
            >
              {(inputProps: any) => (
                <TextField
                  {...inputProps} // Passa as props de input diretamente do InputMask
                  {...other}
                  fullWidth
                  error={!!error}
                  helperText={error ? error.message : helperText}
                />
              )}
            </InputMask>
          );
        }

        // Caso não seja utilizada máscara, renderiza o TextField normalmente.
        return (
          <TextField
            {...field}
            {...other}
            fullWidth
            value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
            error={!!error}
            helperText={error ? error.message : helperText}
          />
        );
      }}
    />
  );
}
